export const AdjustHeight = (controller) => {
  Object.assign(controller, {
    adjustElementHeight: (element) => {
      element.style.height = "auto";
      element.style.height = `${element.scrollHeight}px`;
    },
  });
};
